import { fetchPostOpenBankingShareableLinkHandler } from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

export function usePostOpenBankingShareableLinkMutation() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ token }: { token: string }) => {
      await fetchPostOpenBankingShareableLinkHandler({ token });
    },
  });

  return {
    notifyApplicant: mutateAsync,
    isPending,
  };
}
